import React from 'react';
import ReactSwitch from 'react-switch';
import Text from '@/components/ui/Text';
import { TCITooltip } from '@/components/ui/Tooltip';
import { COLORS } from '@/components/ui/ui.constants';

interface SettingsToggleProps {
  checked: boolean;
  children?: React.ReactNode;
  description: string;
  disabled?: boolean;
  disabledTooltip?: string;
  id: string;
  label: string;
  onChange: (checked: boolean) => void;
}

const SettingsToggle = ({
  checked,
  children,
  description,
  disabled = false,
  disabledTooltip,
  id,
  label,
  onChange,
}: SettingsToggleProps) => {
  const tooltip = disabled ? disabledTooltip : undefined;

  // AIDEV-NOTE: a disabled react-switch is out of the tab order, so this tooltip is hover-only.
  // Keyboard/SR users get the same sentence from `description` -- don't drop it on the
  // assumption the tooltip covers them.
  const toggle = (
    <div className="tw-shrink-0 tw-pt-0.5">
      <ReactSwitch
        checked={checked}
        checkedIcon={false}
        disabled={disabled}
        handleDiameter={20}
        height={24}
        id={id}
        offColor={COLORS['med-grey']}
        uncheckedIcon={false}
        width={48}
        onChange={onChange}
        onColor={COLORS['tci-purple']}
      />
    </div>
  );

  return (
    <div>
      <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
        <div>
          <Text className="tw-cursor-pointer" htmlFor={id} size="sm" tag="label" weight="bold">
            {label}
          </Text>
          <Text className="tw-text-very-dark-grey" size="sm">
            {description}
          </Text>
        </div>
        {tooltip ? (
          <TCITooltip>
            <TCITooltip.Trigger asChild>
              {toggle}
            </TCITooltip.Trigger>
            <TCITooltip.Content>
              {tooltip}
            </TCITooltip.Content>
          </TCITooltip>
        ) : toggle}
      </div>
      {children}
    </div>
  );
};

export default SettingsToggle;
